import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { OperationAssignmentsService } from './operation-assignments.service';
import { UtilsService } from './utils.service';

import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';
import { SPSCommerce_OperationService } from './SPSCommerce.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
    private operationAssignmentsService: OperationAssignmentsService,
  ) {
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
    this.SPSCommerce = this.injector.get(SPSCommerce_OperationService);
  }

  public FootprintApiManager: FootprintApiManager_OperationService;
  public SPSCommerce: SPSCommerce_OperationService;
  public app: app_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    var referenceName = null;    
    return Promise.resolve(this.operationAssignmentsService.isAssigned(referenceName, operationName, mode));
  }
}
